import {RoomManage} from './RoomManage';
import {useRoom} from './useRoom';
import {Room} from './Room';
import {UseConfig, useConfig} from './useConfig';
import {detectUserRole} from './utils/roleDetection';

export const Router = () => {
    const config = useConfig();

    if (config.loading) {
        // show spinner
        return null;
    }
    return <RouterLoadedConfig config={config} />;
};

const RouterLoadedConfig = ({config}: {config: UseConfig}) => {
    // Determine role based on deployment stage (hostname for online, path for local)
    const role = detectUserRole();
    
    const {room, state, setRoomDisplayName, ...other} = useRoom(config, role);

    // For receivers, check if a sender has joined before showing main room
    if (state && role === 'receiver') {
        const hasSender = state.users.some(user => user.role === 'sender');
        if (!hasSender) {
            // Stay in lobby until sender joins
            return (
                <RoomManage
                    room={room}
                    config={config}
                    role={role}
                    state={state}
                    setRoomDisplayName={setRoomDisplayName}
                />
            );
        }
    }

    if (state) {
        return <Room state={state} role={role} setRoomDisplayName={setRoomDisplayName} {...other} />;
    }

    return <RoomManage room={room} config={config} role={role} setRoomDisplayName={setRoomDisplayName} />;
};
